(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-page-recs"]) return;
  try {
    
(function () {
  function loadAleoRecs(root) {
    var el = root.querySelector('.aleo-pdp-recs');
    if (!el) return;
    fetch(el.dataset.url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = document.createElement('div');
        doc.innerHTML = html;
        var fresh = doc.querySelector('.aleo-pdp-recs');
        if (fresh) el.innerHTML = fresh.innerHTML;
      });
  }
  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target.querySelector('.aleo-pdp-recs')) {
      loadAleoRecs(evt.target);
    }
  });
  loadAleoRecs(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
